import React from 'react'
import {RichTextInstructions} from '../../../types/richTextInstructions'

interface RichTextInstructionsViewProps {
  instructions: RichTextInstructions
  className?: string
  'data-cy'?: string
}

const withoutTerminalNewline = (instructions: RichTextInstructions) => {
  const operations = instructions.ops.map(operation => ({
    ...operation,
    attributes: operation.attributes ? {...operation.attributes} : undefined
  }))
  for (let index = operations.length - 1; index >= 0; index -= 1) {
    if (!operations[index].insert.length) continue
    if (operations[index].insert.endsWith('\n')) {
      operations[index].insert = operations[index].insert.slice(0, -1)
    }
    break
  }
  return operations
}

const RichTextInstructionsView = ({instructions, className, ...props}: RichTextInstructionsViewProps) => (
  <span
    className={className}
    data-cy={props['data-cy']}
    style={{
      display: 'block',
      fontFamily: 'FavoritStd-Book, sans-serif',
      fontSize: '1.06rem',
      lineHeight: '1.375rem',
      overflowWrap: 'break-word',
      whiteSpace: 'break-spaces'
    }}
  >
    {withoutTerminalNewline(instructions).map((operation, index) => (
      <span
        key={index}
        style={{
          color: operation.attributes?.color,
          fontFamily: operation.attributes?.bold ? 'FavoritStd-Bold, sans-serif' : undefined,
          fontStyle: operation.attributes?.italic ? 'italic' : undefined,
          textDecoration: operation.attributes?.underline ? 'underline' : undefined
        }}
      >
        {operation.insert}
      </span>
    ))}
  </span>
)

export default RichTextInstructionsView
